import { useTranslation } from 'react-i18next';
import { useActiveEnrolledCount } from 'infrastructure/hooks/patient/use-get-active-enrolled-count';

import MiniStatsActive from './stats-mini-active';
import MiniStatsEnrolled from './stats-mini-enrolled';
import s from './style.module.scss';
import Title from './title';

import type { FC } from 'react';

const CareManagersHeader: FC = () => {
  const { data } = useActiveEnrolledCount();
  const { t } = useTranslation();
  return (
    <div className={s.wrapper}>
      <Title />
      <div className={s.buttons}>
        <MiniStatsActive
          count={data?.activePatients}
          bgColor="#CCCAD7"
          title={t('labels.activePatients')}
        />
        <MiniStatsEnrolled
          count={data?.newlyEnrolledPatients}
          title={t('labels.newlyEnrolledPatients2')}
          bgColor="#FF7A00"
        />
      </div>
    </div>
  );
};

export default CareManagersHeader;
